import { IMapLibreConfig } from '../models/i-maplibre-config';
import { STADIA_MAPS_API_KEY } from './maplibre-api-key.generated';

export const DEFAULT_MAPLIBRE_CONFIG: IMapLibreConfig = {
  styleUrl: `https://tiles.stadiamaps.com/styles/osm_bright.json?api_key=${STADIA_MAPS_API_KEY}`,
  maxZoom: 19,
  initialZoom: 13,
};
